import { motion } from "framer-motion";

const lines = [
  "For the vision is yet for an appointed time;",
  "But at the end it will speak, and it will not lie.",
  "Though it tarries, wait for it;",
  "Because it will surely come,",
  "It will not tarry.",
];

export default function Scripture() {
  return (
    <section id="scripture" className="relative z-10 py-24 md:py-32" data-testid="scripture-section">
      <div className="mx-auto max-w-3xl px-6 text-center md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="font-body text-sm uppercase tracking-[0.28em] text-gold"
        >
          The Scripture Behind the Vision
        </motion.p>

        <motion.span
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mx-auto mt-6 block text-3xl text-gold"
        >
          ✦
        </motion.span>

        <motion.blockquote
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{ show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } } }}
          className="mt-6"
        >
          {lines.map((line, i) => (
            <motion.p
              key={i}
              variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 } }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-2xl italic leading-relaxed text-cream md:text-3xl"
            >
              {line}
            </motion.p>
          ))}
        </motion.blockquote>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="mt-8 font-body text-lg font-medium text-gold-soft"
        >
          — Habakkuk 2:3 (NKJV)
        </motion.p>
      </div>
    </section>
  );
}
